import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=3b093120&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=3b093120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b093120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b093120')) {
      api.createRecord('3b093120', component.options)
    } else {
      api.reload('3b093120', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=3b093120&scoped=true&", function () {
      api.rerender('3b093120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/winners/Detail.vue"
export default component.exports